import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_EN_CURS,
    AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_FINALITZADA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL = null;

const idComentariEnProcesEliminar = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_EN_CURS:
            return action.id;

        case AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_FINALITZADA:
            return null;

        default:
            return state;
    }
};

export default idComentariEnProcesEliminar;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/idComentariEnProcesEliminar.js